<template>
  <v-container>
    <v-list subheader>
      <div class="text-right"><EmailClient /></div>
      <v-subheader>E-Mail an</v-subheader>

      <RowItem
        v-for="dl in dls"
        v-bind:key="dl.description"
        :align="dl.emails.length > 1 ? 'start' : 'center'"
        :title="dl.description.replace('E-Mail an', '').replace(' der', '')"
      >
        <Mailto :dl="dl.emails" :bcc="dl.bcc"
          >{{ joinEmails(dl.emails) }}
        </Mailto>
      </RowItem>
    </v-list>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import { saveChildRoute } from "@/router/helper";
import EmailClient from "@/components/settings/EmailClient";
import Mailto from "@/components/Mailto";
import RowItem from "@/components/RowItem";
import { joinEmails } from "common/utils/helper";

export default defineComponent({
  name: "CourseContact",
  components: {
    EmailClient,
    Mailto,
    RowItem,
  },
  props: {
    id: { type: String },
  },
  computed: {
    courseId() {
      return Number.parseInt(this.id);
    },
  },
  data() {
    return {
      course: {},
      dls: {},
      loading: false,
    };
  },
  methods: {
    joinEmails,
    async getData() {
      if (this.courseId) {
        this.loading = true;
        this.course = await this.apiGet({
          resource: "course/coursepart",
          id: this.courseId,
        });
        this.dls = await this.apiGet({
          resource: "course/mail",
          id: this.courseId,
        });
        this.loading = false;
      }
    },
  },
  watch: {
    async id() {
      await this.getData();
    },
  },
  async created() {
    await this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    saveChildRoute(to, next);
  },
});
</script>
